var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "newExperienceManager" } },
    [
      _vm.detailFormUi && _vm.detailFormUi.name
        ? _c("j-headful", { attrs: { title: _vm.detailFormUi.name } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-page",
          class: { "header-page-long": !_vm.is_sidebar_minimized }
        },
        [
          _c("div", { staticClass: "wrap-left-header" }, [
            _c("img", {
              staticClass: "back-to-list",
              attrs: { src: require("@/assets/icon/arrow-left.svg") },
              on: {
                click: function($event) {
                  _vm.$router.push("/experience-manager")
                }
              }
            }),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: require("@/assets/icon-sidebar/experience-manager.svg")
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.updateTitleFormUi,
                    expression: "updateTitleFormUi"
                  }
                ],
                staticClass: "header-item",
                class: { "header-item--active": _vm.isEditTitleActive }
              },
              [
                _c("div", { staticClass: "badge-type-ui" }, [
                  _vm._v(_vm._s(_vm.isMultipleForm ? "Multiple" : "Single"))
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.detailFormUi ? _vm.detailFormUi.id : ""))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "line" }),
                _vm._v(" "),
                _c("div", { staticClass: "title-wrap" }, [
                  _c(
                    "h3",
                    {
                      staticClass: "title-input-label",
                      style: _vm.isEditTitleActive ? { display: "none" } : {},
                      on: { dblclick: _vm.editTitleFormUi }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.titleFormUi) +
                          "\n            "
                      ),
                      _c("div", { staticClass: "tooltip-component" }, [
                        _vm._v(
                          "\n              Double Click to edit this Title\n            "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.titleFormUi,
                        expression: "titleFormUi"
                      }
                    ],
                    ref: "titleInput",
                    staticClass: "title-input",
                    style: _vm.isEditTitleActive
                      ? {
                          width: _vm.titleFormUi.length * 7.5 + "px",
                          display: "inline-block"
                        }
                      : {},
                    attrs: { type: "text" },
                    domProps: { value: _vm.titleFormUi },
                    on: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        _vm.updateTitleFormUi($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.titleFormUi = $event.target.value
                      }
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _vm.header && _vm.header.title
              ? _c("div", { staticClass: "header-item header-item-source" }, [
                  _c("div", { staticClass: "data-source" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/icon-sidebar/data-manager.svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "data-source-info" }, [
                      _c("p", { staticClass: "data-source-name" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.header ? _vm.header.title : " ") +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "data-source-type" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.detailFormUi
                                ? _vm.reformatTextDataType(
                                    _vm.detailFormUi.type
                                  )
                                : ""
                            ) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.detailFormUi && _vm.detailFormUi.type === "form"
                      ? _c("div", { staticClass: "open-tab" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/icon-sidebar/open-tab.svg")
                            },
                            on: {
                              click: function($event) {
                                _vm.openTable()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "tooltip-component" }, [
                            _vm._v("\n              Open new tab\n            ")
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-ellipsis-v fa-lg popover-config",
            attrs: { id: "popover-config-menu" },
            on: {
              click: function($event) {
                _vm.configPopoverShow = true
              }
            }
          }),
          _vm._v(" "),
          _c(
            "b-popover",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.closePopover,
                  expression: "closePopover"
                }
              ],
              attrs: {
                show: _vm.configPopoverShow,
                target: "popover-config-menu",
                triggers: "click",
                container: "header-page",
                placement: "left"
              },
              on: {
                "update:show": function($event) {
                  _vm.configPopoverShow = $event
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "form-ui-opt", on: { click: _vm.openCodeForm } },
                [_vm._v("\n        View Code\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-ui-opt", on: { click: _vm.deleteFormUi } },
                [_vm._v("\n        Delete\n      ")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-ui-content" }, [
        _c(
          "div",
          {
            staticClass: "body-content",
            class: { "body-content-long": !_vm.is_sidebar_minimized }
          },
          [
            _c("list-view", {
              attrs: {
                "form-detail": _vm.detailFormUi,
                "section-general": _vm.sectionGeneral,
                "section-view": _vm.sectionView,
                "menu-active": _vm.formMenuActive
              },
              on: { "change-view": _vm.changeFormMenu }
            }),
            _vm._v(" "),
            _vm.formMenuActive === "create" || _vm.formMenuActive === "detail"
              ? _c("field-library", {
                  attrs: { "menu-active": _vm.formMenuActive }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showComponent
              ? _c("j-experience-manager-view-content", {
                  attrs: {
                    "form-detail": _vm.detailFormUi,
                    "form-data": _vm.detailFormData,
                    dataset: _vm.detailDataset,
                    menu: _vm.formMenuActive,
                    "is-multiple-form": _vm.isMultipleForm
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appCodeFormDataModal",
          staticClass: "mod-form modal-code-form-data",
          attrs: { centered: "" }
        },
        [
          _vm.showModalViewCode
            ? _c("modal-view-code", {
                attrs: { "json-data": _vm.jsonData, "view-code": _vm.viewCode },
                on: { "close-modal": _vm.closeCodeForm }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43c2a463", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c2a463","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/jExperienceManager.vue
// module id = null
// module chunks = 